import styled from "styled-components";

import { ModalContainer } from "../../../Modal/styled";
export const ImportingModalContainer = styled(ModalContainer)`
  max-width: 965px;
  width: 965px;
  align-items: center;

  > div {
    width: 100%;

    > div {
      width: 100%;
    }
  }
`;
